module.exports = __webpack_public_path__ + "img/lifestyle_thumbnail.a149268a.jpg";